// Auto-tagging rule system

export interface TaggingRule {
  domains?: string[];
  keywords?: string[];
  tags: string[];
}

// 규칙 기반 자동 태깅 룰
export const taggingRules: TaggingRule[] = [
  // 개발 플랫폼
  {
    domains: ['github.com'],
    tags: ['GitHub', '개발', '코드'],
  },
  {
    domains: ['stackoverflow.com', 'stackexchange.com'],
    tags: ['Stack Overflow', '개발', 'Q&A'],
  },
  {
    domains: ['npmjs.com'],
    tags: ['npm', 'JavaScript', '패키지'],
  },
  
  // 한국 블로그 플랫폼
  {
    domains: ['velog.io'],
    tags: ['Velog', '개발', '블로그'],
  },
  {
    domains: ['tistory.com'],
    tags: ['티스토리', '블로그'],
  },
  {
    domains: ['brunch.co.kr'],
    tags: ['브런치', '블로그'],
  },
  {
    domains: ['blog.naver.com'],
    tags: ['네이버 블로그', '블로그'],
  },
  {
    domains: ['medium.com'],
    tags: ['Medium', '블로그'],
  },
  
  // 디자인 & UI
  {
    domains: ['figma.com'],
    tags: ['Figma', '디자인', 'UI/UX'],
  },
  {
    domains: ['dribbble.com'],
    tags: ['Dribbble', '디자인', '영감'],
  },
  {
    domains: ['behance.net'],
    tags: ['Behance', '디자인', '포트폴리오'],
  },
  
  // 뉴스 & 미디어
  {
    domains: ['news.ycombinator.com'],
    tags: ['Hacker News', '뉴스', '개발'],
  },
  {
    domains: ['techcrunch.com'],
    tags: ['TechCrunch', '뉴스', '스타트업'],
  },
  {
    domains: ['youtube.com', 'youtu.be'],
    tags: ['YouTube', '동영상'],
  },
  
  // 학습 & 튜토리얼
  {
    keywords: ['tutorial', '튜토리얼', '강의'],
    tags: ['튜토리얼', '학습'],
  },
  {
    keywords: ['documentation', 'docs', '문서'],
    tags: ['문서', '레퍼런스'],
  },
  
  // 기술 키워드
  {
    keywords: ['react', 'reactjs'],
    tags: ['React', '프론트엔드', 'JavaScript'],
  },
  {
    keywords: ['vue', 'vuejs'],
    tags: ['Vue', '프론트엔드', 'JavaScript'],
  },
  {
    keywords: ['angular'],
    tags: ['Angular', '프론트엔드', 'TypeScript'],
  },
  {
    keywords: ['typescript'],
    tags: ['TypeScript', 'JavaScript'],
  },
  {
    keywords: ['python'],
    tags: ['Python', '프로그래밍'],
  },
  {
    keywords: ['nextjs', 'next.js'],
    tags: ['Next.js', 'React', '프론트엔드'],
  },
];

/**
 * URL과 메타데이터를 기반으로 자동 태그 생성
 */
export function generateAutoTags(url: string, title: string = '', description: string = ''): string[] {
  const tags = new Set<string>();
  const domain = new URL(url).hostname.replace('www.', '');
  const searchText = `${url} ${title} ${description}`.toLowerCase();
  
  // 도메인 기반 룰 적용
  for (const rule of taggingRules) {
    if (rule.domains) {
      for (const ruleDomain of rule.domains) {
        if (domain.includes(ruleDomain)) {
          rule.tags.forEach(tag => tags.add(tag));
        }
      }
    }
    
    // 키워드 기반 룰 적용
    if (rule.keywords) {
      for (const keyword of rule.keywords) {
        if (searchText.includes(keyword.toLowerCase())) {
          rule.tags.forEach(tag => tags.add(tag));
        }
      }
    }
  }
  
  return Array.from(tags);
}
